import { Loader } from '@googlemaps/js-api-loader';

let googleMapsLoaded = false;

export async function loadGoogleMaps(): Promise<void> {
  if (googleMapsLoaded) {
    return Promise.resolve();
  }

  const loader = new Loader({
    apiKey: 'AIzaSyDtn-m5KdS9dJQ2aw6fWFG0ONsUG4s_494',
    version: 'weekly',
    libraries: ['places'] 
  });

  await loader.importLibrary('maps')
  googleMapsLoaded = true;
  window.google = google;
}
